import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FSearchGridMDP from "@/components/generic/FSearchGridMDP";

export default class FindClientDetailsFFomMDP extends FFormMDP {
    childMDP: FFormChildMDP =  new FFormChildMDP();
    constructor(props: {parent: any;onClick: () => void}) {
        super({myRefName:"FindClientDetailsFSearchGridRef",});
        this.addField(new FPhoneFieldMDP({
            dataSelectorKey:"customerPhoneNumber",
            label:"Customer PhoneNumber",
            parentMDP: this.childMDP
        }))
        .addAction(new FFormSubmitBtnMDP({label:"Search",onClick: () => {props.onClick()}}))
    }
}